import { usePointer, useSmoothNumber } from '@monogrid/vue-boost/core'
import { useEventListener, useWindowSize } from '@vueuse/core'
import { gsap } from 'gsap'
import { computed, reactive, ref, toRef } from 'vue'

const getTravel = value => Math.round(value * 100) / 100

const { pointer } = usePointer()
const { width, height } = useWindowSize()

const isPressing = ref(false)
const state = reactive({
  moving: { x: false, y: false },
  travel: { x: 0, y: 0 }
})
const moving = computed(() => state.moving.x || state.moving.y)
const normalizedX = computed(() => pointer.x / width.value || 0)
const normalizedY = computed(() => pointer.y / height.value || 0)
const velocityX = computed(() => gsap.utils.mapRange(-width.value / 2, width.value / 2, 1, -1, state.travel.x))
const velocityY = computed(() => gsap.utils.mapRange(-height.value / 2, height.value / 2, -1, 1, state.travel.y))
const mappedX = computed(() => gsap.utils.mapRange(0, width.value, -1, 1, pointer.x))
const mappedY = computed(() => gsap.utils.mapRange(0, height.value, -1, 1, pointer.y))
const speed = computed(() => Math.max(Math.abs(state.travel.x), Math.abs(state.travel.y)))
const speedNormalized = computed(() => gsap.utils.clamp(0, 1, speed.value))

const smootherX = useSmoothNumber(() => pointer.x, {
  duration: 0.6,
  ease: 'power3',
  onStart: () => (state.moving.x = true),
  onComplete: () => (state.moving.x = false),
  onUpdate: () => {
    state.travel.x = getTravel(smootherX.data.target - smootherX.data.value)
  }
})

const smootherY = useSmoothNumber(() => pointer.y, {
  duration: 0.6,
  ease: 'power3',
  onStart: () => (state.moving.y = true),
  onComplete: () => (state.moving.y = false),
  onUpdate: () => {
    state.travel.y = getTravel(smootherY.data.target - smootherY.data.value)
  }
})

const x = toRef(smootherX.data, 'value')
const y = toRef(smootherY.data, 'value')

useEventListener(document, 'pointerdown', () => (isPressing.value = true))
useEventListener(document, 'pointerup', () => (isPressing.value = false))
useEventListener(window, 'pointerleave', () => (isPressing.value = false))

export function useSmoothPointer () {
  return {
    x,
    y,
    mappedX,
    mappedY,
    moving,
    normalizedX,
    normalizedY,
    speed,
    speedNormalized,
    pointer,
    velocityX,
    velocityY,
    isPressing
  }
}
